// extracted by extract-css-chunks-webpack-plugin
module.exports = {"elevationModalZIndex":"1050","elevationLayoutZIndex":"1030","elevationPopoverZIndex":"1060"};
    if(module.hot) {
      // 1771039639927
      var cssReload = require("../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  